import React from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

import "../_tabs-nav.scss";

export type AvailableIntroTabs = "DetailsTab" | "LocaleTab";

type UserProfileIntroDialogTabsProps = {
    activeTab: AvailableIntroTabs;
    handleChangeTab: (tabName: AvailableIntroTabs) => void;
};

export const UserProfileIntroDialogTabs = (props: UserProfileIntroDialogTabsProps) => {
    const { activeTab, handleChangeTab } = props;
    const { t } = useTranslation();

    return (
        <div className="tabs-nav">
            <div
                className={cx([
                    "tabs-nav__row",
                    {
                        "tabs-nav__row--active": activeTab === "DetailsTab",
                    },
                ])}
            >
                <button className="tabs-nav__link" type="button" onClick={() => handleChangeTab("DetailsTab")}>
                    <span className="paragraph paragraph--no-spacing">
                        {t("Gui.Common.UserProfileIntroDialog.DetailsTabName")}
                    </span>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
            <div
                className={cx([
                    "tabs-nav__row",
                    {
                        "tabs-nav__row--active": activeTab === "LocaleTab",
                    },
                ])}
            >
                <button className="tabs-nav__link" type="button" onClick={() => handleChangeTab("LocaleTab")}>
                    <span className="paragraph paragraph--no-spacing">
                        {t("Gui.Common.UserProfileIntroDialog.LocaleTabName")}
                    </span>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    );
};
